import enProgress from './en';
import ruProgress from './ru';

export default {
  en: {
    ...enProgress,
  },
  ru: {
    ...ruProgress,
  },
};
